"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardRenderDynamicVictoryPoints = void 0;
const CardRenderItemType_1 = require("./CardRenderItemType");
const CardRenderItem_1 = require("./CardRenderItem");
const Size_1 = require("./Size");
class CardRenderDynamicVictoryPoints {
    constructor(item, points, target) {
        this.item = item;
        this.points = points;
        this.target = target;
        this.targetOneOrMore = false;
        this.multirow = false;
        this.anyPlayer = false;
    }
    getPointsHtml() {
        if (this.item === undefined && this.points === 0 && this.target === 0)
            return '?';
        if (this.item === undefined)
            return `${this.points}`;
        if (this.target === this.points)
            return `${this.target}/`;
        if (this.target === Math.abs(this.points))
            return `${this.points}/`;
        return `${this.points}/${this.target}`;
    }
    static asteroids(points, target) {
        return new CardRenderDynamicVictoryPoints(new CardRenderItem_1.CardRenderItem(CardRenderItemType_1.CardRenderItemType.ASTEROIDS), points, target);
    }
    static microbes(points, target) {
        return new CardRenderDynamicVictoryPoints(new CardRenderItem_1.CardRenderItem(CardRenderItemType_1.CardRenderItemType.MICROBES), points, target);
    }
    static animals(points, target) {
        return new CardRenderDynamicVictoryPoints(new CardRenderItem_1.CardRenderItem(CardRenderItemType_1.CardRenderItemType.ANIMALS), points, target);
    }
    static oceans(points, target) {
        const item = new CardRenderItem_1.CardRenderItem(CardRenderItemType_1.CardRenderItemType.OCEANS);
        item.size = Size_1.Size.SMALL;
        return new CardRenderDynamicVictoryPoints(item, points, target);
    }
    static cities(points, target, any = false) {
        const item = new CardRenderItem_1.CardRenderItem(CardRenderItemType_1.CardRenderItemType.CITY);
        item.size = Size_1.Size.SMALL;
        item.anyPlayer = any;
        return new CardRenderDynamicVictoryPoints(item, points, target);
    }
    static jovians(points, target) {
        const item = new CardRenderItem_1.CardRenderItem(CardRenderItemType_1.CardRenderItemType.JOVIAN);
        item.isPlayed = true;
        return new CardRenderDynamicVictoryPoints(item, points, target);
    }
    static floaters(points, target) {
        return new CardRenderDynamicVictoryPoints(new CardRenderItem_1.CardRenderItem(CardRenderItemType_1.CardRenderItemType.FLOATERS), points, target);
    }
    static searchForLife() {
        const item = new CardRenderDynamicVictoryPoints(new CardRenderItem_1.CardRenderItem(CardRenderItemType_1.CardRenderItemType.SCIENCE), 3, 3);
        item.targetOneOrMore = true;
        return item;
    }
    static fighter(points, target) {
        return new CardRenderDynamicVictoryPoints(new CardRenderItem_1.CardRenderItem(CardRenderItemType_1.CardRenderItemType.FIGHTER), points, target);
    }
    static camps(points, target) {
        return new CardRenderDynamicVictoryPoints(new CardRenderItem_1.CardRenderItem(CardRenderItemType_1.CardRenderItemType.CAMPS), points, target);
    }
    static cathedrals(points, target) {
        return new CardRenderDynamicVictoryPoints(new CardRenderItem_1.CardRenderItem(CardRenderItemType_1.CardRenderItemType.CATHEDRALS), points, target);
    }
    static hydroelectric(points, target) {
        return new CardRenderDynamicVictoryPoints(new CardRenderItem_1.CardRenderItem(CardRenderItemType_1.CardRenderItemType.HYDROELECTRIC), points, target);
    }
    static colonies(points, target, any = false) {
        const item = new CardRenderItem_1.CardRenderItem(CardRenderItemType_1.CardRenderItemType.COLONIES);
        item.size = Size_1.Size.SMALL;
        item.anyPlayer = any;
        return new CardRenderDynamicVictoryPoints(item, points, target);
    }
    static science(points, target) {
        return new CardRenderDynamicVictoryPoints(new CardRenderItem_1.CardRenderItem(CardRenderItemType_1.CardRenderItemType.SCIENCE), points, target);
    }
    static preservation(points, target) {
        return new CardRenderDynamicVictoryPoints(new CardRenderItem_1.CardRenderItem(CardRenderItemType_1.CardRenderItemType.PRESERVATION), points, target);
    }
    static resourceCube(points, target) {
        return new CardRenderDynamicVictoryPoints(new CardRenderItem_1.CardRenderItem(CardRenderItemType_1.CardRenderItemType.RESOURCE_CUBE), points, target);
    }
    static data(points, target) {
        return new CardRenderDynamicVictoryPoints(new CardRenderItem_1.CardRenderItem(CardRenderItemType_1.CardRenderItemType.DATA_RESOURCE), points, target);
    }
    static moon(points, target) {
        return new CardRenderDynamicVictoryPoints(new CardRenderItem_1.CardRenderItem(CardRenderItemType_1.CardRenderItemType.MOON), points, target);
    }
    static moonMiningTile(points, any = false) {
        const item = new CardRenderItem_1.CardRenderItem(CardRenderItemType_1.CardRenderItemType.MOON_MINE);
        item.size = Size_1.Size.SMALL;
        item.anyPlayer = any;
        return new CardRenderDynamicVictoryPoints(item, points, points);
    }
    static moonColonyTile(points) {
        const item = new CardRenderItem_1.CardRenderItem(CardRenderItemType_1.CardRenderItemType.MOON_COLONY);
        item.size = Size_1.Size.SMALL;
        return new CardRenderDynamicVictoryPoints(item, points, 1);
    }
    static moonRoadTile(points, any = false) {
        const item = new CardRenderItem_1.CardRenderItem(CardRenderItemType_1.CardRenderItemType.MOON_ROAD);
        item.size = Size_1.Size.SMALL;
        item.anyPlayer = any;
        return new CardRenderDynamicVictoryPoints(item, points, 1);
    }
    static questionmark() {
        return new CardRenderDynamicVictoryPoints(undefined, 0, 0);
    }
    static any(points) {
        const item = new CardRenderDynamicVictoryPoints(undefined, points, points);
        item.anyPlayer = true;
        return item;
    }
    static vermin() {
        const cities = new CardRenderItem_1.CardRenderItem(CardRenderItemType_1.CardRenderItemType.CITY);
        cities.size = Size_1.Size.TINY;
        cities.anyPlayer = false;
        const item = new CardRenderDynamicVictoryPoints(cities, -1, 1);
        item.multirow = true;
        return item;
    }
}
exports.CardRenderDynamicVictoryPoints = CardRenderDynamicVictoryPoints;
//# sourceMappingURL=CardRenderDynamicVictoryPoints.js.map